import { useEffect, useState } from 'react';

import { queryString } from 'utilities';
import { FACEBOOK_APP_ID } from 'settings';

// For some reason, Facebook passes this hash when the user completes the share
const FACEBOOK_RETURN_ERROR_CODE = '4201';
const FACEBOOK_URL = 'https://www.facebook.com/';

const useFacebookRedirect = () => {
  const [facebookStatus, setFacebookStatus] = useState(null);

  useEffect(() => {
    if (window.document.referrer !== FACEBOOK_URL) {
      return;
    }

    handleFacebookReturn();
  }, []);

  function handleFacebookReturn() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const hasErrorCode = urlSearchParams.get('error_code') === FACEBOOK_RETURN_ERROR_CODE;

    if (hasErrorCode) {
      urlSearchParams.delete('error_code');
      urlSearchParams.delete('error_message');
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${urlSearchParams.toString()}`
      );
      setFacebookStatus('canceled');
    }

    if (!hasErrorCode) {
      window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
      setFacebookStatus('success');
    }
  }

  function redirectToFacebook(shareUrl: string) {
    const queryParams = {
      app_id: FACEBOOK_APP_ID,
      display: 'popup',
      href: window.encodeURIComponent(shareUrl),
      redirect_uri: window.encodeURIComponent(window.location.href),
    };

    window.location.href = `${FACEBOOK_URL}dialog/share?${queryString(queryParams)}`;
  }

  return { redirectToFacebook, facebookStatus };
};

export default useFacebookRedirect;
